import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useState } from 'react';
import Icon from '../Icon/Icon.js';
import { convertToUrl } from '../../utils/cloudinary.js';
import { PictureReplacement, Picture } from './style.js';
import { jsx } from 'react/jsx-runtime';
import { MEDIA_CAMERA_UNAVAILABLE } from '../../icons/MEDIA_CAMERA_UNAVAILABLE.js';

var _excluded = ["img", "sizes", "className", "errorIcon", "lazy", "alt", "retina", "formats"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CloudinaryPicture = function CloudinaryPicture(_ref) {
  var img = _ref.img,
    sizes = _ref.sizes,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$errorIcon = _ref.errorIcon,
    errorIcon = _ref$errorIcon === void 0 ? null : _ref$errorIcon,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? null : _ref$alt,
    _ref$retina = _ref.retina,
    retina = _ref$retina === void 0 ? false : _ref$retina,
    _ref$formats = _ref.formats,
    formats = _ref$formats === void 0 ? ['avif', 'jp2', 'jpg'] : _ref$formats,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(!(img !== null && img !== void 0 && img.cloudinaryUriTemplate)),
    _useState2 = _slicedToArray(_useState, 2),
    hasBrokenImageUrl = _useState2[0],
    setHasBrokenImageUrl = _useState2[1];
  var onErrorCallback = function onErrorCallback() {
    setHasBrokenImageUrl(true);
  };
  if (hasBrokenImageUrl) {
    return /*#__PURE__*/jsx(PictureReplacement, {
      className: "".concat(className, " uikit-picture--broken"),
      children: errorIcon || /*#__PURE__*/jsx(Icon, {
        className: "sg-picture-icon",
        path: MEDIA_CAMERA_UNAVAILABLE,
        size: "xl",
        sizeMobile: "l"
      })
    });
  }
  return /*#__PURE__*/jsx(Picture, {
    className: className,
    children: sizes === null || sizes === void 0 ? void 0 : sizes.map(function (size, sourceIndex) {
      var isLastSource = sourceIndex === sizes.length - 1;
      var width = size.width,
        height = size.height,
        breakpoint = size.breakpoint,
        ar = size.ar;
      return formats.map(function (format, formatIndex) {
        var isLastFormat = formatIndex === formats.length - 1;
        var url = convertToUrl(img, width * 1.5, height * 1.5, {
          format: format
        }, ar);
        var srcSet = retina ? "".concat(url, ", ").concat(convertToUrl(img, width * 2, height * 2, {
          format: format
        }, ar), " 2x") : url;
        var key = "".concat(sourceIndex, "_").concat(format);
        if (isLastSource && isLastFormat) {
          return /*#__PURE__*/jsx("img", _objectSpread({
            alt: alt || null,
            role: alt ? null : 'presentation',
            srcSet: srcSet,
            src: url,
            onError: onErrorCallback,
            loading: lazy ? 'lazy' : 'eager',
            height: height,
            width: width
          }, rest), key);
        }
        return /*#__PURE__*/jsx("source", {
          type: "image/".concat(format),
          media: breakpoint ? "(min-width: ".concat(breakpoint, "px)") : null,
          srcSet: srcSet,
          height: height,
          width: width
        }, key);
      });
    })
  });
};
var CloudinaryPicture$1 = CloudinaryPicture;

export { CloudinaryPicture$1 as default };
//# sourceMappingURL=CloudinaryPicture.js.map
